// src/pages/projects/hooks/useTeamMemberDialog.js
import { useState } from 'react';
import { DEFAULT_NEW_MEMBER } from '../../../constants/teamConstants';

/**
 * Custom hook to manage team member dialog (add/edit)
 */
const useTeamMemberDialog = (
  projectId, 
  { addProjectTeamMember, updateProjectTeamMember }
) => {
  // Dialog states
  const [dialogState, setDialogState] = useState({
    isOpen: false,
    mode: 'add', // 'add' or 'edit'
    member: { ...DEFAULT_NEW_MEMBER }
  });
  
  // Open dialog for adding a new member
  const openAddDialog = () => {
    setDialogState({
      isOpen: true,
      mode: 'add',
      member: { ...DEFAULT_NEW_MEMBER }
    });
  };
  
  // Open dialog for editing an existing member
  const openEditDialog = (member) => {
    setDialogState({
      isOpen: true,
      mode: 'edit',
      member: { ...member }
    });
  };
  
  // Close dialog
  const closeDialog = () => {
    setDialogState(prev => ({
      ...prev,
      isOpen: false
    }));
  };
  
  // Handle save (add or edit)
  const handleSave = async () => {
    const { mode, member } = dialogState;
    
    try {
      if (mode === 'add') {
        await addProjectTeamMember(projectId, member);
      } else {
        await updateProjectTeamMember(projectId, member._id, {
          role: member.role,
          permissions: member.permissions
        });
      }
      
      // Close dialog
      closeDialog();
      return true;
    } catch (err) {
      console.log(`Failed to ${mode} team member:`, err);
      return false;
    }
  };

  // Update member state helper
  const updateMember = (field, value) => {
    setDialogState(prev => {
      const updatedMember = { ...prev.member };
      
      if (field.startsWith('permissions.')) {
        const permissionKey = field.split('.')[1];
        updatedMember.permissions = {
          ...updatedMember.permissions,
          [permissionKey]: value
        };
      } else {
        updatedMember[field] = value;
      }
      
      return {
        ...prev,
        member: updatedMember
      };
    });
  };
  
  return {
    // States
    dialogState,
    
    // Methods
    openAddDialog,
    openEditDialog,
    closeDialog,
    handleSave,
    updateMember
  };
};

export default useTeamMemberDialog;